module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('bread-crumb', {
    attrs: {
      "routeName": 'Careers'
    }
  }), _vm._v(" "), _c('hero', {
    attrs: {
      "backgroundImage": _vm.slide_image,
      "content": _vm.slider_text,
      "top": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('p', {
    staticClass: "is-white subtitle is-5 m-b-50",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns m-b-10 is-multiline"
  }, _vm._l((_vm.careers), function(career) {
    return _c('div', {
      staticClass: "column is-6"
    }, [_c('ul', [_c('li', {
      staticClass: "is-white subtitle is-bold is-5"
    }, [_vm._v(_vm._s(career.value))])])])
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43fd7a93","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/pages/careers.vue
// module id = 1140
// module chunks = 1